export { default } from './SyncDetails';
